export default __webpack_public_path__ + "static/media/property_896.02b15823.png";